import React from "react";

const Header = () => {
	return (
		<header className="header">
			<p>Weather App</p>
		</header>
	);
};

export default Header;
